import React, { useState } from 'react';

import {
  Avatar,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from '@mui/material';
import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { getIcon } from '../../../utils/IconHandler';
import ViewUserModal from '../../location_management/staff/ViewUserModal';
import EditUserModal from '../../location_management/staff/EditUserModal';
import ResetPasswordModal from '../../location_management/staff/ResetPasswordModal';
import { permissionOptions } from '../../../utils/Enums';

export default function StaffTable({ users, onResetPassword, onEditUser, roles, onEditSchedule, loading }) {

  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);

  const hasPermission = (permissionId) => {
    const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
    return userPermissions.includes(permissionId);
  };

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper}>
          <Box sx={{ overflowX: 'auto' }}>
            <Box sx={{ minWidth: 1000 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell width="20%">{t('name')}</TableCell>
                    <TableCell width="15%" align="center">{t('phone')}</TableCell>
                    <TableCell width="25%" align="center">{t('email')}</TableCell>
                    <TableCell width="10%" align="center">{t('role')}</TableCell>
                    <TableCell width="20%" align="right">{t('actions')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Box py={1}  justifyContent="center">
                          <CircularProgress size={32} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
                      <TableRow key={user.id}>
                        <TableCell component="th" scope="row">
                          <Avatar alt={`${user.firstName} ${user.lastName}`} src={user.profilePictureUrl} />
                        </TableCell>
                        <TableCell>{user.firstName} {user.lastName}</TableCell>
                        <TableCell align="center">{user.phone}</TableCell>
                        <TableCell align="center">{user.email}</TableCell>
                        <TableCell align="center">
                          <Chip color="info" size="small" variant="outlined" label={user.role.name} />
                        </TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => {
                            setSelectedUser(user);
                            setIsViewModalOpen(true);
                          }}>
                            {getIcon('eye')}
                          </IconButton>
      
                          {hasPermission(permissionOptions.find(p => p.label === 'UPDATE_STAFF').id) && (
                            <>
                              <IconButton onClick={() => onEditSchedule(user)}>{getIcon('time')}</IconButton>
                              <IconButton onClick={() => {
                                setSelectedUser(user);
                                setIsResetPasswordModalOpen(true);
                              }}>
                                {getIcon('lock')}
                              </IconButton>
                              <IconButton onClick={() => {
                                setSelectedUser(user);
                                setIsEditModalOpen(true);
                              }}>
                                {getIcon('settings')}
                              </IconButton>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {selectedUser && (
        <>
          <ViewUserModal
            open={isViewModalOpen}
            onClose={() => setIsViewModalOpen(false)}
            user={selectedUser}
          />
          <EditUserModal
            open={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            user={selectedUser}
            onSave={(updatedUser) => onEditUser(selectedUser.email, updatedUser)}
            roles={roles}
          />
          <ResetPasswordModal
            open={isResetPasswordModalOpen}
            onClose={() => setIsResetPasswordModalOpen(false)}
            onSave={(newPassword) => onResetPassword(selectedUser.email, newPassword)}
          />
        </>
      )}
    </>
  );
}
